module.exports = __webpack_public_path__ + "static/media/facebook.3ec7a209.png";